export default [
  {
    path: "/notification-setting/:filterProp?",
    name: "NotificationSetting",
    component: () =>
      import("@/views/Page/NotificationSetting/NotificationSettings.vue"),
    meta: {
      title: "Cyber Mode | NotificationSetting",
      mainTrKeys: ["notificationsetting", "role"],
    },
    props: true,
  },
];
